import Vue from "vue";

export const eventBus = new Vue({
    data() {
        return {
            debounce: null,
        }
    },
    methods: {
        triggeredAddItemToCart() {
            console.log('triggeredAddItemToCart');
            this.$emit('triggeredAddItemToCart');
        },
        storedFrontImageData(event) {
            console.log('storedFrontImageData');
            this.$emit('storedFrontImageData', event);
        },
        notification(message) {
            this.$emit('notification', message);
        },
        fileUploadStateChanged(state) {
            this.$emit('fileUploadStateChanged', state)
        },
        fileUploadAborted() {
            this.$emit('fileUploadAborted');
        },
        fileUploadProgress(progress) {
            this.$emit('fileUploadProgress', progress);
        },
        openAnalysisTool(tool) {
            this.$emit('openAnalysisTool', tool);
        },
        cartItemPricingInvalid(event){
            console.log('FIRED');
            clearTimeout(this.debounce);
            this.debounce = setTimeout(() => {
                this.$emit('cartItemPricingInvalid', event);
            }, 500);
        },
        logout() {
            this.notification({
                type: "success",
                header: "Logout erfolgreich",
                body: "Sie wurden erfolgreich ausgeloggt."
            });
        }
    }
});